module.exports = __webpack_public_path__ + "img/payment-pic-01.6ec1542e.png";